import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import useTranslationSetup from "../../utils/useTranslationSetup";
import "./styles.css";

const AudioSaveSuccessDialog = ({
  isDialogOpen,
  header,
  description,
  btnText,
  onClick,
  celebrationImage,
  celebrationImageAlt = "",
}) => {
  const { activeLanguage } = useTranslationSetup();

  return (
    <Dialog className="custom-dialog audio-save-success" open={isDialogOpen}>
      <DialogTitle className="audio-save-success-title">
       
        <Typography
          fontSize="16px"
          textAlign="center"
          margin="25px 5px 8px"
          color="#353535"
          className="custom-ff-medium"
          lang={activeLanguage}
        >
          {header}
        </Typography>
        <Typography
          fontSize="14px"
          textAlign="center"
          padding="0 14% 0px"
          color="#6E6E6E"
          className="custom-ff-regular"
          lang={activeLanguage}
        >
          {description}
        </Typography>
        <img
          src={celebrationImage}
          alt={celebrationImageAlt}
          className="audio-save-success-celebration-img"
        />
      </DialogTitle>

      <DialogContent>
        <Box>
          <Button
            className="audio-save-success-get-result-button btn-primary"
            variant="contained"
            lang={activeLanguage}
            disableElevation
            onClick={onClick}
          >
            {btnText}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
export default AudioSaveSuccessDialog;
